import React from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./ReportsCalendarContainer.styled";

const ReportsCalendarContainer = () => {
  const iframe =
    '<iframe title="Calendar" src="https://app.powerbi.com/reportEmbed?reportId=aa79e33e-6abc-45c5-a611-f44f00132334&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsCalendarContainer;
